import { api } from '$app/api';

export const getCampaignById = (campaignId) => api.get(`/campaigns/${campaignId}`).then((res) => res.data);

export const updateCampaign = (campaignId, campaignEdit) =>
  api.patch(`/campaigns/${campaignId}`, campaignEdit);
